import { render, staticRenderFns } from "./ConsultPurchase.vue?vue&type=template&id=fc17e5b0&scoped=true"
import script from "./ConsultPurchase.vue?vue&type=script&lang=js"
export * from "./ConsultPurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc17e5b0",
  null
  
)

export default component.exports